import React from 'react';

import { useTranslation, useBi } from '@wix/yoshi-flow-editor';

import GroupIcon from '../../assets/icons/groups-new.svg';

import { st, classes } from './SocialGroupLink.st.css';

import { useSocialGroups } from '../../contexts/SocialGroups/SocialGroupsContext';
import { FCWithChildren } from '@wix/challenges-web-library';
import { memberWebAppButtonClick as memberWebAppButtonClickV2 } from '@wix/bi-logger-challenges-member-web/v2';
import { ButtonNames } from '../../contexts/main/biInterfaces';

interface ISocialGroupLink
  extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  slug: string;
  showIcon?: boolean;
  biButtonName?: string;
  className?: string;
  iconOnly?: boolean;
}

export const SocialGroupLink: FCWithChildren<ISocialGroupLink> = (props) => {
  const { groupPageUrl } = useSocialGroups();
  const {
    slug,
    showIcon = true,
    biButtonName = ButtonNames.GroupSmall,
    iconOnly = false,
  } = props;

  const bi = useBi();

  const { t } = useTranslation();

  const url = `${groupPageUrl?.url}/${slug}`;

  const renderIcon = () => {
    if (!showIcon) {
      return null;
    }

    if (iconOnly) {
      return (
        <a
          data-hook="social-group-link"
          target="_blank"
          href={url}
          className={classes.iconLink}
          rel="noreferrer"
          onClick={() => {
            bi.report(
              memberWebAppButtonClickV2({
                buttonName: biButtonName,
              }),
            );
          }}
        >
          <GroupIcon className={classes.groupIcon} />
        </a>
      );
    }

    return <GroupIcon className={classes.groupIcon} />;
  };

  return (
    <span className={st(classes.root, props.className)} style={props.style}>
      {renderIcon()}
      {!iconOnly && (
        <a
          data-hook="social-group-link"
          target="_blank"
          href={url}
          className={classes.link}
          rel="noreferrer"
          onClick={() => {
            bi.report(
              memberWebAppButtonClickV2({
                buttonName: biButtonName,
              }),
            );
          }}
        >
          {t('live-site.groups.link-cta')}
        </a>
      )}
    </span>
  );
};

SocialGroupLink.displayName = 'SocialGroup';
